import { render, staticRenderFns } from "./myAppointDetail.vue?vue&type=template&id=2c0705ab&scoped=true"
import script from "./myAppointDetail.vue?vue&type=script&lang=js"
export * from "./myAppointDetail.vue?vue&type=script&lang=js"
import style0 from "./myAppointDetail.vue?vue&type=style&index=0&id=2c0705ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0705ab",
  null
  
)

export default component.exports